import { render, staticRenderFns } from "./AssignRightsModal.vue?vue&type=template&id=51560330&"
import script from "./AssignRightsModal.vue?vue&type=script&lang=js&"
export * from "./AssignRightsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports